// extracted by mini-css-extract-plugin
module.exports = {"containerOutside":"_2p-F43dWryoX8Qe4258Yao","containerInside":"_2JEsNefZ9J0Y96pOoNlsNM","heading":"_318igZ28LfIKPcD41n0k9m"};